import { Text } from '@react-pdf/renderer';
import { ReactNode } from 'react';

const ProgressTitle = ({ value, color }: { value: ReactNode; color: string }) => (
    <Text style={{ color, fontFamily: 'Bold' }}>{value}</Text>
);
export default ProgressTitle;
